import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Clock } from 'lucide-react';

interface VideoPreviewProps {
  title: string;
  thumbnail: string;
  duration: number;
  onChangeVideo: () => void;
}

export function VideoPreview({ title, thumbnail, duration, onChangeVideo }: VideoPreviewProps) {
  useLanguage();
  // Format duration from seconds to mm:ss
  const formatDuration = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="border rounded-lg overflow-hidden">
      <div className="relative aspect-video bg-muted">
        <img
          src={thumbnail}
          alt={title}
          className="w-full h-full object-cover"
        />
        <div className="absolute bottom-2 right-2 bg-black/80 text-white px-2 py-1 rounded text-sm flex items-center gap-1">
          <Clock className="w-3 h-3" />
          {formatDuration(duration)}
        </div>
      </div>
      <div className="p-4 space-y-3">
        <div className="flex items-start justify-between gap-4">
          <div className="flex-1 min-w-0">
            <h3 className="font-semibold text-lg truncate">{title}</h3>
            <div className="flex items-center gap-2 mt-1">
              <Badge variant="secondary" className="text-xs">
                {translateInterfaceText("Host VSL")}</Badge>
            </div>
          </div>
          <Button variant="outline" size="sm" onClick={onChangeVideo}>
            {translateInterfaceText("Alterar vídeo")}</Button>
        </div>
      </div>
    </div>
  );
}
